// apps/merchant-v3/src/components/topbar/EmailVerifyChip.tsx
//
// Phase 6 amend #10 topbar redesign — "Email not verified" call-out
// chip surfaced on the TopBar when `user.emailVerified === false`.
// Click routes to /settings/profile so the merchant can re-trigger the
// verification email.

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useUser } from '@/store/user';

export function EmailVerifyChip(): JSX.Element | null {
  const { t } = useTranslation('common');
  const user = useUser();
  if (!user) return null;
  // Treat absent as verified — Wave 1 user mapper does not project the
  // field yet (Phase 6 amend #10 follow-up); only render when an
  // explicit `false` reaches the store.
  if (user.emailVerified !== false) return null;
  return (
    <Link
      to="/settings/profile"
      data-testid="topbar-email-verify-chip"
      aria-label={t('topbar.emailNotVerifiedAria', { defaultValue: 'Email not verified — open profile to resend verification' })}
      className="inline-flex shrink-0 items-center gap-1 rounded-md bg-orange-500 px-2.5 py-1 text-xs font-semibold text-white shadow-sm hover:bg-orange-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
    >
      {t('topbar.emailNotVerified', { defaultValue: 'Email not verified' })}
    </Link>
  );
}

export default EmailVerifyChip;
